import WalletSetup from './WalletSetup';

export default WalletSetup;
